import React from 'react';
import { useTranslation } from 'react-i18next';
import './CancelSubscriptionModal.scss';

type Props = {
    open: boolean;
    loading?: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

const CancelSubscriptionModal: React.FC<Props> = ({ open, loading, onClose, onConfirm }) => {
    const { t } = useTranslation();

    if (!open) return null;

    return (
        <div className="modalOverlay" role="dialog" aria-modal="true">
            <div className="modal">
                <h2>{t('pages.subscription.cancel.modal.title')}</h2>
                <p>{t('pages.subscription.cancel.modal.text')}</p>

                <div className="modalActions">
                    <button className="button-cancelSub button-secondary" onClick={onClose} disabled={!!loading}>
                        {t('pages.subscription.cancel.modal.cancel')}
                    </button>

                    <button className="button-cancelSub button-danger" onClick={onConfirm} disabled={!!loading}>
                        {t('pages.subscription.cancel.modal.confirm')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CancelSubscriptionModal;
